let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("go3oZ")).then(() => parcelRequire('cxPmB'));